import type { VariantProps } from 'class-variance-authority';
import type React from 'react';

import { buttonVariants } from '@/components/core/button';
import { Skeleton } from '@/components/core/skeleton';
import { cn } from '@/shared/helpers';

type ButtonSkeletonProps = React.ComponentProps<'div'> & {
  size?: VariantProps<typeof buttonVariants>['size'];
};

export function ButtonSkeleton({ className, size, ...props }: ButtonSkeletonProps) {
  const isIconSize = size?.startsWith('icon');

  return (
    <Skeleton
      aria-hidden="true"
      className={cn(
        buttonVariants({ variant: 'outline', size }),
        !isIconSize && 'w-20',
        'pointer-events-none border-transparent bg-muted text-transparent shadow-none hover:bg-muted',
        className,
      )}
      {...props}
    />
  );
}
